// import { reminder } from "../../../model/reminder";

import { access } from "../../../model/access";

export interface IState {
    accesses: Array<access>;
    selectedContactAccesses: Array<access>;
    isLoadingAccesses: boolean;
    // openDialog: boolean;
}


export const DefaultState = (): IState => ({
    accesses: [],
    selectedContactAccesses: [],
    isLoadingAccesses: false,
})
